export default __webpack_public_path__ + "static/media/allmeal.ad9d67df.jpg";